<template>
  <v-app>
    <v-system-bar app height="30" dark>
      <v-icon small>mdi-laptop</v-icon>
      <span v-if="!initialized">Carregando...</span>
      <span v-else class="text-truncate pl-1 pr-3">
        {{ data?.session?.name }}
      </span>
      <v-spacer></v-spacer>
      <span>{{ currentTime | date("HH:mm") }}</span>
    </v-system-bar>
    <v-main :class="{ 'privacy-mode-on': privacyMode }" class="d-flex">
      <LeftSideBar
        v-if="initialized && userToken"
        :token="tokenPair"
        :data="data"
        :user="userData"
        :privacyMode.sync="privacyMode"
        @logout="logout"
      />
      <MainVirtualPos
        v-if="initialized && userToken"
        :token="tokenPair"
        :data="data"
        :user="userData"
      />
    </v-main>

    <UserLoginModal
      v-if="initialized"
      :visible="!userToken"
      :users="data?.Users || []"
      :token="posToken"
      @login="login"
    />
    <CalculatorModal ref="calculator" />
    <QZTrayManagement v-if="initialized && userToken" />
  </v-app>
</template>
<script>
import VIRTUAL_POS from "@/services/staff/virtualPos";
import UserLoginModal from "../../components/staff/virtualPos/UserLoginModal.vue";
import LeftSideBar from "../../components/staff/virtualPos/LeftSideBar.vue";
import MainVirtualPos from "../../components/staff/virtualPos/MainVirtualPos.vue";
import CalculatorModal from "../../components/virtualPos/CalculatorModal.vue";
import QZTrayManagement from "../../components/global/qzPrinter/QZTrayManagement.vue";
export default {
  name: "VirtualPos",
  metaInfo: {
    title: "Virtual POS",
  },
  components: {
    UserLoginModal,
    LeftSideBar,
    MainVirtualPos,
    CalculatorModal,
    QZTrayManagement,
  },
  data() {
    return {
      error: null,
      initialized: false,
      posToken: null,
      userToken: null,
      userData: null,
      data: null,

      privacyMode: false,

      interval: null,
      currentTime: new Date(),
    };
  },
  methods: {
    async initialize() {
      try {
        const code = this.$route.params.code;
        const { token: tempToken } = await VIRTUAL_POS.verifyCode(code);
        if (!tempToken) throw new Error("Invalid code");
        this.posToken = tempToken;

        await this.renewToken();

        this.initialized = true;
      } catch (e) {
        this.error = e;
      }
    },
    async renewToken() {
      try {
        const { token: posToken, ...data } = await VIRTUAL_POS.renewToken(
          this.posToken
        );
        if (!posToken) throw new Error("Could not renew token");
        this.posToken = posToken;
        this.data = data;
      } catch (e) {
        this.error = e;
      }
    },
    async login({ user, token }) {
      try {
        this.userData = user;
        this.userToken = token;
        // go to fullscreen navegation
        window.document.documentElement.requestFullscreen();
      } catch (e) {
        this.error = e;
      }
    },
    logout() {
      this.userData = null;
      this.userToken = null;
    },
  },
  computed: {
    tokenPair() {
      return {
        posToken: this.posToken,
        userToken: this.userToken,
      };
    },
  },
  mounted() {
    this.initialize();
    this.interval = setInterval(() => {
      this.currentTime = new Date();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style>
.private-value {
  transition: filter 0.2s ease-in-out;
}

.privacy-mode-on .private-value {
  filter: blur(5px);
}

.privacy-mode-on .reveal-on-hover:hover .private-value {
  filter: blur(0);
}
</style>
